import React from 'react';
import {SubmitHandler} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {IPortMonitorListItem} from 'features/port/model/PortMonitor/IPortMonitor';
import {
    allValueToUndefined,
    buildFiltersSearchParams,
    dateRangeToFilters,
    sortToUrlFilters,
} from 'shared/lib/filterHelper';

import PortIncidentsFiltersForm, {IPortIncidentFiltersForm} from './PortIncidentsFiltersForm';

interface IPortIncidentsFiltersFormHandlerProps {
    monitors: IPortMonitorListItem[],
    onSuccess: () => void,
    handleClose: () => void,
}

const PortIncidentsFiltersFormHandler: React.FC<IPortIncidentsFiltersFormHandlerProps> = ({
    monitors,
    onSuccess,
    handleClose,
}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const onSubmit: SubmitHandler<IPortIncidentFiltersForm> = ({
        portMonitor,
        resolved,
        // eslint-disable-next-line camelcase
        created_at,
        // eslint-disable-next-line camelcase
        resolved_at,
        orderBy,
    }) => {
        const data: Record<string, string | undefined> = {
            'portMonitor.uuid': allValueToUndefined(portMonitor),
            resolved: allValueToUndefined(resolved),
            ...sortToUrlFilters(orderBy),
        };
        dateRangeToFilters(created_at, data, 'created_at');
        dateRangeToFilters(resolved_at, data, 'resolved_at');

        setSearchParams(buildFiltersSearchParams(searchParams, data));

        onSuccess();
    };

    return (
        <PortIncidentsFiltersForm
            monitors={monitors}
            onSubmit={onSubmit}
            button={
                <ModalBlockButton
                    primaryButtonText={t`Применить фильтры`}
                    primaryButtonType="submit"
                    secondaryButtonOnClick={handleClose}
                />
            }
        />
    );
};

export default PortIncidentsFiltersFormHandler;
